import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';

const ResetPassword = () => {
  const [contactNumber, setContactNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const location = useLocation();

  React.useEffect(() => {
    if (location.state) {
      setContactNumber(location.state.contactNumber);
    }
  }, [location.state]);

  const handleOTPChange = (e) => setOtp(e.target.value);
  const handlePasswordChange = (e) => setNewPassword(e.target.value);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError(null); 
    setSuccess(null); 

    try {
      const data = { contact_number: contactNumber, otp, new_password: newPassword };
      console.log('Sending data:', data);
      const response = await axios.post('https://doc.teamhalt.com/document/api/v1/reset-password/', data, {
      // const response = await axios.post('http://127.0.0.1:8000/document/api/v1/reset-password/', data, {
        headers: { 'Content-Type': 'application/json' }
      });

      console.log('Response:', response);
      if (response.status === 200 && response.data.message) {
        setSuccess(response.data.message);
      } else {
        setError('Failed to reset password. Please try again.');
      }
    } catch (error) {
      console.error('Error resetting password:', error);

      if (error.response) {
        console.log('Error response data:', error.response.data);
        setError(error.response.data.error || 'Error resetting password. Please try again.');
      } else if (error.request) {
        setError('No response from the server. Please try again.');
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
    }
  };

  return (
    <div className="auth-wrapper">
  <form className="auth-card" onSubmit={handleResetPassword}>
    <div className="logo-container">
      <img src="logo.png" alt="Logo" className="logo" />
      <h1 className="logo-name">TeamHalt Document Manager</h1>
    </div>
    <h2>Reset Password</h2>
    <input
      type="tel"
      name="contactNumber"
      placeholder="Enter your Contact Number"
      value={contactNumber}
      disabled
    />
    <input
      type="number"
      name="otp"
      placeholder="Enter OTP"
      value={otp}
      onChange={handleOTPChange}
      required
    />
    <input
      type="password"
      name="newPassword"
      placeholder="Enter New Password"
      value={newPassword}
      onChange={handlePasswordChange}
      required
    />
    {error && <p className="error">{error}</p>}
    {success && <p className="success">{success}</p>}
    <button type="submit">Reset Password</button>
    <Link className="link" to="/">Go Back To Login</Link>
  </form>
</div>

  );
};

export default ResetPassword;